import React, { useMemo } from "react";
import { useWindowDimensions } from "react-native";

import SkeletonPlayerDetailView from "./SkeletonPlayerDetailView";

import useMobileScreen from "@/hooks/useMobileScreen";
import { useTheme } from "@/providers/ThemeProvider";
import chunkArrayWithPadding from "@/utils/chunkWithPadding";
import { skeletonColumnsForWidth } from "@/utils/skeletonColumns";

/**
 * Container component for skeleton loading state of player detail view
 */
const SkeletonPlayerDetailContainer = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const { width } = useWindowDimensions();
  const numCols = skeletonColumnsForWidth(width);
  const isSmallScreen = useMobileScreen();
  const skeletonMetrics = chunkArrayWithPadding<boolean[]>(
    new Array(6).fill(true),
    numCols
  );

  const skeletonMetricsChart = useMemo(() => [], []);

  return (
    <SkeletonPlayerDetailView
      skeletonMetrics={skeletonMetrics}
      skeletonMetricsChart={skeletonMetricsChart}
      isSmallScreen={isSmallScreen}
      isDark={isDark}
    />
  );
};

export default SkeletonPlayerDetailContainer;
